import { useQuery } from "@tanstack/react-query";
import { nutritionAPI } from "@/lib/nutrition-api";
import type { TagMetadataResponse } from "@/lib/nutrition-api";

/**
 * Hook to fetch all tag metadata for nutrition forms
 * This replaces individual API calls with a single unified endpoint
 */
export const useTagMetadata = () => {
  return useQuery({
    queryKey: ["tag-metadata"],
    queryFn: () => nutritionAPI.tagMetadata.get(),
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
  });
};

/**
 * Hook to fetch food sources for dropdowns
 * Now uses the unified tag metadata endpoint
 */
export const useFoodSources = () => {
  return useQuery({
    queryKey: ["tag-metadata"],
    queryFn: () => nutritionAPI.tagMetadata.get(),
    select: (data: TagMetadataResponse) => 
      data.sources_and_brands.food_sources.map((source) => source.name),
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * Hook to fetch food brands for dropdowns
 * Now uses the unified tag metadata endpoint
 */
export const useFoodBrands = () => {
  return useQuery({
    queryKey: ["tag-metadata"],
    queryFn: () => nutritionAPI.tagMetadata.get(),
    select: (data: TagMetadataResponse) => 
      data.sources_and_brands.food_brands.map((brand) => brand.name),
    staleTime: 1000 * 60 * 5,
  });
};

